// local storage
export const SURVEY_DONE = "surveyDone";
export const MATCHING_DONE = "matchingDone";
export const QUESTIONS = "questions";
export const USER = "user";
